import { get, post } from '../Services/http';
import { catchError } from './Error.action';

export const CAMPAIGN_LOAD = 'CAMPAIGN_LOAD';
export const CAMPAIGN_LOAD_ERROR = 'CAMPAIGN_LOAD_ERROR';
export const CAMPAIGN_RECEIVE = 'CAMPAIGN_RECEIVE';
export const CAMPAIGN_TOGGLE = 'CAMPAIGN_TOGGLE';

const rootRoute = '/api/campaign/';

export const getCampaignList = () => (dispatch, getState) => {
   
    return get(rootRoute + 'getCampaigns')
        .then(response => response.json())
        .then(response => dispatch(showList(response)))
        .then(response => dispatch(receive(response)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const load = () => (dispatch, getState) => {
   return;
    return get(rootRoute + 'getCampaigns')
        .then(response => response.json())
        .then(response => dispatch(showList(response)))
        .then(response => dispatch(receive(response)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const showList = (list) => (dispatch, getState) => {
    return list;
}

export const loadError = error => ({
    type: CAMPAIGN_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {
    return ({
        type: CAMPAIGN_RECEIVE,
        payload: {
            listObjects: data,
        }
    });
}